import _ from 'underscore';
import { MMAAssetConfigs } from './config';

export const headlineFields = _.map(_.range(MMAAssetConfigs.MAX_HEADLINES), i => `Headline${i}`);
export const longHeadlineFields = _.map(_.range(MMAAssetConfigs.MAX_LONGHEADLINES), i => `LongHeadline${i}`);
export const descriptionFields = _.map(_.range(MMAAssetConfigs.MAX_DESCRIPTIONS), i => `Description${i}`);

export const ResponsiveAdScenarios = {
  MMASearch: 'MMASearch',
  MMAResponsive: 'MMAResponsive',
  NonMMAResponsive: 'NonMMAResponsive',
};

export const AdEditFields = {
  Headline: 'Headline',
  LongHeadline: 'LongHeadline',
  Description: 'Description',
  Text: 'Text',
  BusinessName: 'BusinessName',
};

export const assetSuggestionType = {
  // use for asset suggestions
  [AdEditFields.Headline]: 'headline',
  [AdEditFields.LongHeadline]: 'description',
  [AdEditFields.Description]: 'description',
  [AdEditFields.Text]: 'description',
  [AdEditFields.BusinessName]: 'business',
};

export const singleAssetSuggestionType = {
  [AdEditFields.Headline]: 'shortHeadline',
  [AdEditFields.LongHeadline]: 'longHeadline',
  [AdEditFields.Text]: 'description',
};
